.timeline {
  margin-top: clamp(2rem, 4vw, 3rem);
}
